import url from './url';



export default url(({ questionId = ':questionId' }) => `/questions/${questionId}/edit`);
